import styled from 'styled-components'

export const SearchForm = styled.form`
  display: flex;
  flex-wrap: wrap;
`

export const SearchFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px 57px;
  color: #646877;
  margin-bottom: 0;
  border: 1px solid #f3f4f7;
  justify-content: space-between;
  @media (min-width: 576px) {
    height: 274px;
    padding: 24px 24px 50px 24px;
    border: none;
    border-radius: 8px;
  }
`

export const SearchInput = styled.input`
  height: 47px !important;
  font-size: 14px;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  outline: none;
  padding: 16px;
  width: 100%;
  margin-bottom: 40px;
  position: relative;
  background-color: #fff;
  line-height: 21px;
  color: #999999;

  &:focus {
    background-color: #fff;
    outline: none;
    color: #646877;
  }
  &:active {
    background-color: #fff;
    outline: none;
    color: #646877;
  }

  @media (max-width: 576px) {
    border: none;
    padding: 0;
    margin: 0;
  }
`

export const SearchFormBtnBlock = styled.div`
  margin: 0 auto;
`

export const HorizontalLine = styled.hr`
  margin: 0;
`

export const ModalSubHeaderWrapper = styled.div`
  margin-bottom: 16px;
  @media (max-width: 576px) {
    margin-bottom: 0;
  }
`
